import { Table } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import type { VendorPersonType } from '@econtractor/types';
import SpinnerBlock from 'components/others/SpinnerBlock';
import VendorPersonsTableBody from './VendorPersonsTableBody';

interface VendorPersonsTableProps {
    rows: VendorPersonType[];
    showSpinner?: boolean;
    onEdit: (row: VendorPersonType) => void;
    onDelete: (row: VendorPersonType) => void;
    onOpenContacts: (row: VendorPersonType) => void;
    onSetPrimary: (row: VendorPersonType, isPrimary: boolean) => void;
}

const VendorPersonsTable = ({
    rows,
    showSpinner = false,
    onEdit,
    onDelete,
    onOpenContacts,
    onSetPrimary,
}: VendorPersonsTableProps) => {
    const { t } = useTranslation(['Vendors']);

    return (
        <div className="position-relative">
            <SpinnerBlock onlyBlur={true} show={showSpinner} />
            <div className="crm-table-wrap">
                <Table className="VendorPersonsTable table-hover mb-0">
                    <thead>
                        <tr className="bg-light">
                            <td className="head-primary" title={t('persons.fields.primary')}></td>
                            <td className="head-name">{t('persons.fields.fullName')}</td>
                            <td className="head-status">{t('persons.fields.position')}</td>
                            <td className="head-action">{t('persons.fields.action')}</td>
                        </tr>
                    </thead>
                    <VendorPersonsTableBody
                        rows={rows}
                        onEdit={onEdit}
                        onDelete={onDelete}
                        onOpenContacts={onOpenContacts}
                        onSetPrimary={onSetPrimary}
                    />
                </Table>
            </div>
        </div>
    );
};

export default VendorPersonsTable;
